<template>
   <section class="homecategories">
      <div class="container">
         <div class="homecategories__title">
            <h4>Take the path <span>you</span> wish to travel.</h4>
            <p>Witness the most Instagrammable artist murals on the Esplanade, trade raves for red wine and sun lounges for handcrafted leather ones. Spend the day getting lost in the details, questioning and exploring. Whatever you decide, you’ll be sure to leave enchanted and enriched.</p>
         </div>
         <div class="homecategories__wrap">
            
            <a class="homecategories__item" @click='navigate(cat)' v-for="cat in category" :key="cat.id">
               <div class="homecategories__item-img" v-bind:style="{ background: 'url(' + cat.linkAvatar + ')' + 'no-repeat center center' }"></div>
               <div class="homecategories__item-content">
                  <h5 href="#">{{ cat.linkText }}</h5>
               </div>
            </a>

         </div>
      </div>
   </section>
</template>

<script>
   import { CATEGORIES } from '../js/categories.js';

   export default {
      name: 'HomeCategories',
      data: function() {
         return {
            category: CATEGORIES
         }
      },

      methods: {
         navigate (cat) {
            let params = { urlSegment: cat.urlSegment, id: cat.id, screenId: this.$router.currentRoute.params.screenId }
            this.$router.push({ name: 'category', params: params})
         }
      },
   }
</script>
